import { render } from "./Gene_Details.vue?vue&type=template&id=8c2859aa"
import script from "./Gene_Details.vue?vue&type=script&lang=js"
export * from "./Gene_Details.vue?vue&type=script&lang=js"

import "./Gene_Details.vue?vue&type=style&index=0&id=8c2859aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__